export default __webpack_public_path__ + "static/media/Frame1.b22b46d6.png";